import React, { useEffect } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { FiRefreshCcw } from "react-icons/fi";
import { INIT_TITLE } from '../../configurations/initUrls';

export default function Card({ isBorder = false, bgColor="bg-white", borderColor = "border-gray-400", title, subTitle, children, isBack = false, isRefresh = false, doRefresh }) {
    const navigate = useNavigate()
    
    return (
        <div class={"p-3 shadow-xl hover:shadow-2xl" + (isBorder ? " rounded-3xl border-t-4 " + borderColor : "") + (" " + bgColor)}>
            {(title || isBack || isRefresh) && <h1 class="text-gray-900 font-bold text-xl leading-8 my-1 flex items-center">
                {
                    isBack &&
                    <button title='Back' className='mr-1 p-1 hover:bg-gray-200 hover:rounded-lg' onClick={() => navigate(-1)}>
                        <MdArrowBack />
                    </button>
                }
                {title && <h1 className='flex items-center w-full'>{title}</h1>}
                {
                    isRefresh &&
                    <button title='Refresh' className='ml-2 mr-1 p-1 text-green-700 hover:bg-gray-200 hover:rounded-lg active:bg-gray-300 active:rounded-lg' onClick={doRefresh}>
                        <FiRefreshCcw />
                    </button>
                }
            </h1>}
            {subTitle && <h3 class="text-gray-600 font-lg text-semibold leading-6">{subTitle}</h3>}
            {children}
        </div>
    )
}
